import ColumnTypes from '@/utils/ColumnTypes';

function getColumns() {
	let arr = [
		{
			key: 'index',
			label: '序号',
			type: ColumnTypes.TextCell,
			fixed: 'left',
			minWidth: '100',
		},
		{
			key: 'commissionRate',
			label: '佣金率',
			type: ColumnTypes.TextCell,
			fixed: 'left',
			minWidth: '100',
		},
		{
			key: 'serviceRate',
			label: '服务费率',
			type: ColumnTypes.TextCell,
			fixed: 'left',
			minWidth: '100',
		},
		{
			key: 'status',
			label: '状态',
			type: () => import('./tableCell/statusCell'),
			fixed: 'left',
			minWidth: '100',
		},
		{
			key: 'operations',
			label: '操作',
			type: ColumnTypes.ButtonsCell,
			minWidth: '100',
			align: 'right',
		},
	];

	return arr;
}

export default getColumns;
